<div #form="ngForm" ngForm [ngClass]="styles.formGroupBg">

	<div [ngClass]="styles.externalPresentersRow" flex-justify="end">
		<button type="button" vbBtnPrimary [disabled]="!addEnabled" (click)="addExternalPresenter()">
			{{'Add' | translate}}
		</button>
	</div>

	<div *ngFor="let presenter of webcast.externalPresenters; index as index; trackBy trackByIndex">
		<div *ngIf="presenter.isEdit; else presenterDetail" #presenterGroup="ngModelGroup" [ngModelGroup]="'presenter' + (webcast.externalPresenters.length - index)" [ngClass]="styles.externalPresentersFormGroup">
			<vb-ui-form-group [controlClass]="styles.inlineRequired">
				<input type="text" name="name" class="form-control" required #editName="ngModel" [(ngModel)]="presenter.edits.name" uiControl [placeholder]="'Name' | translate" [attr.aria-label]="'Name' | translate" trim="blur"/>
				<div *ngIf="editName.touched && editName.invalid" class="margin-bottom-10" role="alert" vbUiErrorMessage uiValidation>
					{{ 'ThisFieldIsRequired' | translate }}
				</div>
			</vb-ui-form-group>

			<vb-ui-form-group>
				<input type="text" name="title" class="form-control" [placeholder]="'Title' | translate" [attr.aria-label]="'Title' | translate" [(ngModel)]="presenter.edits.title" uiControl trim="blur"/>
			</vb-ui-form-group>

			<vb-ui-form-group [controlClass]="styles.inlineRequired">
				<input type="text" name="email" class="form-control" [disabled]="!presenter.isNew" [placeholder]="'Email' | translate" #editEmail="ngModel" [(ngModel)]="presenter.edits.email" (ngModelChange)="validateGroup(presenterGroup)" uiControl vbEmail required trim="blur"/>
				<div *ngIf="editEmail.touched && editEmail.invalid && editEmail.errors" class="margin-bottom-10" role="alert" vbUiErrorMessage uiValidation>
					@if (editEmail.errors.required) {
						{{ 'ThisFieldIsRequired' | translate }}
					} @else if (editEmail.errors.vbEmail) {
						{{ 'InvalidEmailError' | translate }}
					} @else if (editEmail.errors.emailInUse) {
						{{ 'EmailInUse' | translate }}
					}
				</div>
			</vb-ui-form-group>

			<button type="button" vbBtnPrimary [attr.aria-label]="'Apply' | translate" [tooltip]="'Apply' | translate" container="body" delay="500" [disabled]="presenterGroup.invalid" (click)="applyPresenterEdits(presenter)">
				<span class="glyphicons ok_2"></span>
			</button>
			<button type="button" vbBtnSecondary [attr.aria-label]="'Cancel' | translate" [tooltip]="'Cancel' | translate" container="body" delay="500" (click)="cancelPresenterEdit(presenter, index)">
				<span class="glyphicons remove_2"></span>
			</button>
		</div>

		<ng-template #presenterDetail>
			<div [ngClass]="styles.externalPresentersRow">
				<span flex="fill">
					<header>{{presenter.data.name}} {{ presenter.data.title ? '(' + presenter.data.title + ')' : '' }}</header>
					{{presenter.data.email}}
				</span>
				<button type="button" [attr.aria-label]="'Edit' | translate" [tooltip]="'Edit' | translate" container="body" delay="500" (click)="editPresenter(presenter)">
					<span class="glyphicons pencil"></span>
				</button>
				<button type="button" *ngIf="!presenter.isNew" [disabled]="presenter.sendingEmail" [attr.aria-label]="'ResendEmail' | translate" [tooltip]="'ResendEmail' | translate" container="body" delay="500" (click)="resendEmail(presenter)">
					<span class="glyphicons envelope"></span>
				</button>
				<button type="button" [attr.aria-label]="'Remove' | translate" [tooltip]="'Remove' | translate" container="body" delay="500" (click)="removeExternalPresenter(index)">
					<span class="glyphicons bin"></span>
				</button>
			</div>
		</ng-template>
	</div>

</div>
